export const DAYS = [
  { value: 'monday', label: 'Lunes', short: 'Lun.', code: 'L' },
  { value: 'tuesday', label: 'Martes', short: 'Mar.', code: 'M' },
  { value: 'wednesday', label: 'Miércoles', short: 'Mie.', code: 'X' },
  { value: 'thursday', label: 'Jueves', short: 'Jue.', code: 'J' },
  { value: 'friday', label: 'Viernes', short: 'Vie.', code: 'V' },
  { value: 'saturday', label: 'Sábado', short: 'Sáb.', code: 'S' },
  { value: 'sunday', label: 'Domingo', short: 'Dom.', code: 'D' }
];

export const MONTHS = [
  { value: 'january', label: 'Enero', code: 'Ene.' },
  { value: 'february', label: 'Febrero', code: 'Feb.' },
  { value: 'march', label: 'Marzo', code: 'Mar.' },
  { value: 'april', label: 'Abril', code: 'Abr.' },
  { value: 'may', label: 'Mayo', code: 'Mayo' },
  { value: 'june', label: 'Junio', code: 'Jun.' },
  { value: 'july', label: 'Julio', code: 'Jul.' },
  { value: 'august', label: 'Agosto', code: 'Ago.' },
  { value: 'september', label: 'Septiembre', code: 'Sep.' },
  { value: 'october', label: 'Octubre', code: 'Oct.' },
  { value: 'november', label: 'Noviembre', code: 'Nov.' },
  { value: 'december', label: 'Diciembre', code: 'Dic.' }
];

export const GENDERS = [
  { value: 'male', label: 'Masculino' },
  { value: 'female', label: 'Femenino' },
  { value: 'other', label: 'Otro' }
];

export const GENERAL_RULES = {
  BOOKING_CATALOG_MAXIMUM: 'BOOKING_CATALOG_MAXIMUM',
  BOOKING_DAILY_MAXIMUM: 'BOOKING_DAILY_MAXIMUM',
  LOYALTY_CARD_MAXIMUM: 'LOYALTY_CARD_MAXIMUM',
  LOYALTY_CARD_EXPIRATION: 'LOYALTY_EXPIRATION',
  LOYALTY_REWARD_EXPIRATION: 'LOYALTY_REWARD_EXPIRATION'
};

export const STORAGE = {
  ONBOARDING_SLIDES: 'ONBOARDING_SLIDES'
}
